// #ifdef APP-PLUS
export const BASE_URL = 'https://dc.fcredit.kz' //发版的正式地址
// export const BASE_URL = 'http://dc-hui.fcredit.kz:8189' //灰度地址
// export const BASE_URL = 'http://165.154.179.207:60002' //测试/地址
// export const BASE_URL = 'http://123.58.192.141:8187'
// #endif
// #ifndef APP-PLUS
export const BASE_URL = 'https://dc.fcredit.kz';//正式
// export const BASE_URL = 'http://test-dc-2.fcredit.kz'; //测试
// #endif
import {
	userStore
} from '@/stores/user.js';
const logout = () => {
	const useUserStore = userStore();
	useUserStore.resetData()
	uni.showToast({
		icon: 'none',
		title: 'Срок действия входа истек'
	})
	const pages = getCurrentPages()
	const page = pages[pages.length - 1].route
	if (page !== 'pages/login/login') {
		uni.redirectTo({
			url: '/pages/login/login'
		})
	}
}

const DEBUG = false;
let system = uni.getSystemInfoSync()
let lastRequestTask;

/**
 * 网络请求
 */
export function request(params, isToken = true, showLoading = false) {
	return new Promise((resolve, reject) => {
		const path = params.url;
		const isHttps = path.startsWith('http://') || path.startsWith('https://')
		const url = isHttps ? path : `${BASE_URL}${params.url}`
		const data = params.data || {}
		if (path == '/bury2/add') {
			data.type = uni.getStorageSync('channel') || 'no channel'
			data.type2 = 'ggId:' + uni.getStorageSync('analytics') + ',fbp:' + uni.getStorageSync('fbp') + ',fbc:' + uni.getStorageSync('fbc')
		} else {
			data.app = 'Быстрые займы.kz'
			// #ifdef APP-PLUS
			data.ver = plus.runtime.version
			data.channel = plus.runtime.channel
			// #endif
			data.ver = uni.getStorageSync('api_ver') || '2.1.6'
			data.token = uni.getStorageSync('token') || ''
			data.from = 'h5'
			data.fromWeb = 'h5.fcredit.kz'
			data.platform = system.osName
			data.model = system.model
			data.deviceId = system.deviceId
			data.userAgent = navigator.userAgent
			data.channel = uni.getStorageSync('channel') || ''
			data.applocale = uni.getStorageSync('app_locale') || 'ru'
			data.ga4fAppInstanceId = uni.getStorageSync('analytics') || ''
			data.fbp = uni.getStorageSync('fbp') || ''
			data.fbc = uni.getStorageSync('fbc') || ''
			data.ttp = uni.getStorageSync('ttp') || ''
			data.ttclid = uni.getStorageSync('ttclid') || ''
			data.sourceid = uni.getStorageSync('sourceid') || ''
			data.transaction_id = uni.getStorageSync('click_id') || ''
			data.lead_id = uni.getStorageSync('lead_id') || ''
			data.utm_term = uni.getStorageSync('utm_term') || uni.getStorageSync('partner_id') || ''
			data.aff_sub = uni.getStorageSync('aff_sub') || ''
			data.appsflyer_id = uni.getStorageSync('appsflyer_id')
			data.devgaid = uni.getStorageSync('devgaid')
			data.gaid = uni.getStorageSync('devgaid')
		}
		const header = params.header || {}
		const method = params.method || 'POST'
		const loadingTitle = params.loadingTitle || 'Загрузка...'
		if (isToken) {
			header.token = uni.getStorageSync('token') || ''
		}
		header.app = 'kz'
		if (showLoading) {
			uni.showLoading({
				title: loadingTitle,
				mask: false
			});
		}
		lastRequestTask = uni.request({
			url,
			data,
			header,
			method,
			success: res => {
				if (showLoading) {
					uni.hideLoading()
				}
				if (res.statusCode === 200) {
					if (res.data.code === 0) {
						resolve([null, res.data])
					} else if (res.data.code === 301) {
						logout()
						resolve([res.data, null])
					} else {
						resolve([res.data, null])
					}
				} else {
					if (res.statusCode === 501) {
						logout()
					}
					resolve([res.data, null])
				}
				printLog({
					url,
					method,
					data,
					response: res.data
				})
			},
			fail: (e) => {
				if (showLoading) {
					uni.hideLoading()
				}
				printLog({
					url,
					method,
					data,
					// #ifdef MP-WEIXIN
					error: e,
					// #endif
					// #ifdef MP-ALIPAY
					error: e.data,
					// #endif
				})
				resolve([e, null])
			}
		})
	})
}

export function abortTask() {
	if (lastRequestTask) {
		lastRequestTask.abort()
	}
}

function printLog({
	url,
	method,
	data,
	response,
	error
}) {
	if (DEBUG) {
		console.log('请求结果: ' + (response ? 'success' : 'fail'))
		console.log('╔════════start════════╗')
		console.log('╠═url:    %c ' + url, 'color:blue')
		console.log('╠═method: %c ' + method, 'color:blue')
		console.log('╠═data:   %c ' + JSON.stringify(data, null, 2), 'color:red')
		if (response) {
			console.log('╠═response:', response)
		}
		if (error) {
			console.error('╠═response:', error)
		}
		console.log('╚══════════end═════════╝')
	}
}